export function getAgeFromRand(_rand: number): number {
    return Math.max(
        Math.min(
            Math.round(Math.abs(_rand) * 80) + 12,
            115
        ),
        8
    );
}